var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productCarousel"},[_c('ul',{staticClass:"productCarousel__list"},_vm._l((_vm.data),function(item){return _c('li',{staticClass:"productCarousel__item"},[_c('productCard',{attrs:{"addItemToCard":_vm.addItemToCard,"data":item}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee5bd78","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/productCarouselComponent.vue
// module id = 223
// module chunks = 0